import { c as _c } from "react/compiler-runtime";
import { SphereAvatar } from "@components/header/sphere-avatar";
import { PALETTE_VARS } from "@styles/palette-vars";
import { MENU_WIDTH, UserMoreInfoMenu } from "@components/user-more-info-menu/user-more-info-menu";
import { Box } from "@mui-wrapper";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
import { useAppSelector } from "@store/store-helper";
import { currentUserSelector } from "@store/user/user-selector";
import { TeamIcon, Tooltip } from "@flat-ui";
import { getPendingUserIcon, getUserInitials } from "@utils/user-utils";
/** Time to wait between hover and open the dialog */
const enterDelay = 200;

/**
 * The surface of this tooltip is the member card itself, so it drops everything flat-ui gives a
 * plain tooltip: the dark background, the border, the padding and the width cap. The margin needs
 * `!important` because flat-ui sets its placement margins through a more specific selector.
 */
export const userCardTooltipSx = {
  width: MENU_WIDTH,
  maxWidth: "none",
  backgroundColor: "background.paper",
  border: "none",
  padding: "0px",
  margin: "0px !important"
};

/**
 * Shows the user avatar and when hovered shows a menu with more info about the user.
 */
export function UserAvatarWithMenu(t0) {
  const $ = _c(12);
  const {
    member,
    shouldHideWhiteRim: t1,
    size: t2
  } = t0;
  const shouldHideWhiteRim = t1 === undefined ? true : t1;
  const size = t2 === undefined ? "small" : t2;
  const currentUser = useAppSelector(currentUserSelector);
  const isCurrentUser = member?.identity === currentUser?.identity;
  if (!member) {
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <></>;
      $[0] = t3;
    } else {
      t3 = $[0];
    }
    return t3;
  }
  let t3;
  if ($[1] !== member) {
    t3 = <Box onClick={_temp}><UserMoreInfoMenu member={member} /></Box>;
    $[1] = member;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      display: "block",
      cursor: "pointer"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== isCurrentUser || $[5] !== member || $[6] !== shouldHideWhiteRim || $[7] !== size) {
    t5 = FaroCoreApiUtils.Member.isTeam(member) ? <SphereAvatar icon={<TeamIcon sx={{
      width: "20px",
      height: "20px"
    }} />} size={size} shouldHideWhiteRim={true} backgroundColor={PALETTE_VARS.Avatar.defaultBg} /> : <SphereAvatar initials={getUserInitials(member)} src={member?.thumbnailUrl} icon={getPendingUserIcon(member)} shouldUseSimplifiedAvatar={!isCurrentUser} shouldHideWhiteRim={shouldHideWhiteRim} size={size} />;
    $[4] = isCurrentUser;
    $[5] = member;
    $[6] = shouldHideWhiteRim;
    $[7] = size;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <Tooltip enterDelay={enterDelay} enterNextDelay={enterDelay} title={t3} disableInteractive={false} tooltipSx={userCardTooltipSx} sx={t4}>{t5}</Tooltip>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
function _temp(event) {
  return event.stopPropagation();
}